import { render, staticRenderFns } from "./section-team.vue?vue&type=template&id=1841c81c&"
import script from "./section-team.vue?vue&type=script&lang=js&"
export * from "./section-team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports